import { Component, Input, OnInit } from '@angular/core';

import { Header, IStrapiDocument } from 'src/app/interfaces/strapi';
import { AuthService } from 'src/app/services/auth.service';

import StrapiService from 'src/app/services/strapi.service';
import { NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-marketing-header',
    templateUrl: './marketing-header.component.html',
    styleUrls: ['./marketing-header.component.scss'],
    imports: [NgIf, RouterLink],
})
export class MarketingHeaderComponent implements OnInit {
  @Input() public pageScrolled = false;

  public headerData: Header | undefined;

  constructor(
    public readonly auth: AuthService,
    public readonly strapi: StrapiService
  ) {}

  ngOnInit(): void {
    this.strapi
      .getDocumentByUID('header', 'header')
      .subscribe((data: IStrapiDocument<Header>) => {
        this.headerData = this.parseHeaderData(data.data.attributes);
      });
  }

  private parseHeaderData(page: Header): Header {
    const parsed = <Header>{};
    if (page.logo) parsed.logo = page.logo;

    return parsed;
  }
}
